import { Trans } from '@lingui/macro';
import { DEFAULT_REDIRECT_URI } from '../../constants';
import React from 'react';

export default function ChangeEmailFail() {
  const redirectToHome = () => {
    window.location.href = DEFAULT_REDIRECT_URI;
  };
  return (
    <div className="text-slate-600">
      <div
        style={{ fontWeight: 'bold', fontSize: '30px', textAlign: 'center' }}
      >
        <Trans>Liên kết đã được sử dụng</Trans>
      </div>
      <div
        style={{ textAlign: 'center', marginBottom: '50px', width: '500px' }}
      >
        <Trans>
          Liên kết này không được sử dụng nhiều lần, bạn đã thay đổi email trước
          đó. Vui lòng quay lại trang chủ Connections
        </Trans>
      </div>
      <div className='flex justify-center'>
        <button
          onClick={() => redirectToHome()}
          className="px-5 py-2 text-white transition duration-300 rounded bg-luat_HN_primary hover:bg-luat_HN_primary_hover text-[20px]"
        >
          <Trans>Về trang chủ</Trans>
        </button>
      </div>
    </div>
  );
}
